import React from 'react';
import './styles.css';

const WeddingDivider = () => (
  <div className="wedding-divider-wrapper" aria-hidden="true">
    <div className="wedding-divider">
      <svg viewBox="0 0 500 44" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
        {/* Left line */}
        <line x1="0" y1="22" x2="178" y2="22" stroke="#d4a5a5" strokeWidth="0.7"/>
        {/* Left leaves */}
        <path d="M178 22 Q170 13 161 18 Q163 25 178 22Z" fill="#8a9a8a" opacity="0.5"/>
        <path d="M167 22 Q161 12 152 14 Q153 22 167 22Z" fill="#7a8b7a" opacity="0.38"/>
        <line x1="170" y1="22" x2="167" y2="13" stroke="#8a9a8a" strokeWidth="0.7" opacity="0.45"/>
        {/* Center diamond */}
        <path d="M250 13 L258 22 L250 31 L242 22Z" fill="#d4a5a5" opacity="0.45"/>
        <path d="M250 16 L256 22 L250 28 L244 22Z" fill="#c49090" opacity="0.65"/>
        {/* Flanking dots */}
        <circle cx="236" cy="22" r="2" fill="#d4a5a5" opacity="0.55"/>
        <circle cx="264" cy="22" r="2" fill="#d4a5a5" opacity="0.55"/>
        <circle cx="229" cy="22" r="1.2" fill="#d4a5a5" opacity="0.35"/>
        <circle cx="271" cy="22" r="1.2" fill="#d4a5a5" opacity="0.35"/>
        {/* Right leaves - mirror */}
        <path d="M322 22 Q330 13 339 18 Q337 25 322 22Z" fill="#8a9a8a" opacity="0.5"/>
        <path d="M333 22 Q339 12 348 14 Q347 22 333 22Z" fill="#7a8b7a" opacity="0.38"/>
        <line x1="330" y1="22" x2="333" y2="13" stroke="#8a9a8a" strokeWidth="0.7" opacity="0.45"/>
        {/* Right line */}
        <line x1="322" y1="22" x2="500" y2="22" stroke="#d4a5a5" strokeWidth="0.7"/>
      </svg>
    </div>
  </div>
);

export default WeddingDivider;
